import { render } from "./EventStatus.vue?vue&type=template&id=252bd201&scoped=true"
import script from "./EventStatus.vue?vue&type=script&lang=js"
export * from "./EventStatus.vue?vue&type=script&lang=js"

import "./EventStatus.vue?vue&type=style&index=0&id=252bd201&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-252bd201"

export default script